import script from "./article-list.vue?vue&type=script&setup=true&lang=js"
export * from "./article-list.vue?vue&type=script&setup=true&lang=js"

import "./article-list.vue?vue&type=style&index=0&id=2f82bac2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f82bac2"]])

export default __exports__